export function normalizeLogisticRequestAddressText(
  value: string | null | undefined,
): string {
  return (value ?? '').toLowerCase().replace(/ё/g, 'е').trim();
}

export function looksLikeCoordinates(value: string): boolean {
  const text = value.trim();

  if (!text || /[a-zа-я]/i.test(text)) return false;

  const cleaned = text.replace(/[\s,.;:+\-()]/g, '');

  if (!cleaned || !/^\d+$/.test(cleaned)) return false;

  return (text.match(/\d+(?:[.,]\d+)?/g) ?? []).length >= 2;
}
